// services/payment.service.js
import { http, URL } from "./http.service";

export const verifyPaymentCredentials = async (gateway, credentials, businessUuid, businessName) => {
    try {
        console.log('Sending verification request as JSON:', { gateway, credentials, businessUuid, businessName });

        const response = await http.post(`${URL}/payment/verify-credentials`, {
            gateway: gateway,
            credentials: credentials,
            businessUuid: businessUuid,
            businessName: businessName
        }, {
            headers: {
                'Content-Type': 'application/json'
            }
        });

        console.log('Verification response:', response.data);
        return response.data;
    } catch (error) {
        console.error(`Error verifying ${gateway} credentials:`, error);

        if (error.response) {
            throw new Error(error.response.data.message || `Verification failed: ${error.response.status}`);
        } else if (error.request) {
            throw new Error('Network error: Unable to connect to server');
        } else {
            throw new Error(`Verification error: ${error.message}`);
        }
    }
};

export const getBusinessPaymentMethods = async (businessId) => {
    try {
        const response = await http.get(`${URL}/payment/business/${businessId}/payment-methods`);
        return response.data;
    } catch (error) {
        console.error("Error fetching business payment methods:", error);
        return {
            success: false,
            data: {
                razorpay: { configured: false, isVerified: false },
                cashfree: { configured: false, isVerified: false },
                enabledGateway: 'none'
            }
        };
    }
};

export const getBusinessPaymentDetails = async (businessId) => {
    try {
        const response = await http.get(`${URL}/payment/business/${businessId}/payment-details`);
        return response.data;
    } catch (error) {
        console.error("Error fetching business payment details:", error);
        throw error;
    }
};

export const removePaymentMethod = async (businessId, gateway) => {
    try {
        const response = await http.delete(`${URL}/payment/business/${businessId}/payment-methods/${gateway}`);
        return response.data;
    } catch (error) {
        console.error(`Error removing ${gateway}:`, error);
        throw error;
    }
};

// Test connection
export const testPaymentConnection = async () => {
    try {
        const response = await http.get(`${URL}/payment/test`);
        return response.data;
    } catch (error) {
        console.error("Payment service test failed:", error);
        throw error;
    }
};
export const createRazorpayOrder = async (businessUuid, amount, orderData) => {
    try {
        const response = await http.post(`${URL}/payment/razorpay/create-order`, {
            businessUuid,
            amount: amount * 100, // Convert to paise
            currency: "INR",
            ...orderData
        });
        return response.data;
    } catch (error) {
        console.error("Error creating Razorpay order:", error);
        throw error;
    }
};

export const verifyRazorpayPayment = async (businessUuid, paymentData) => {
    try {
        const response = await http.post(`${URL}/payment/razorpay/verify`, {
            businessUuid,
            ...paymentData
        });
        return response.data;
    } catch (error) {
        console.error("Error verifying Razorpay payment:", error);
        throw error;
    }
};

// services/paymentGateway.service.js
export const createCashfreeOrder = async (businessUuid, amount, orderData) => {
    try {
        console.log('Creating Cashfree order:', { businessUuid, amount, orderData });

        const response = await http.post(`${URL}/payment/cashfree/create-order`, {
            businessUuid,
            amount: amount,
            currency: "INR",
            ...orderData
        }, {
            headers: {
                'Content-Type': 'application/json'
            },
            timeout: 15000
        });

        console.log('Cashfree order response:', response.data);
        return response.data;

    } catch (error) {
        console.error('Error creating Cashfree order:', error);

        if (error.response) {
            throw new Error(error.response.data.message || `Cashfree error: ${error.response.status}`);
        } else if (error.request) {
            throw new Error('Network error: Unable to connect to Cashfree');
        } else {
            throw new Error(`Cashfree error: ${error.message}`);
        }
    }
};

export const verifyCashfreePayment = async (businessUuid, paymentData) => {
    try {
        const response = await http.post(`${URL}/payment/cashfree/verify`, {
            businessUuid,
            ...paymentData
        });
        return response.data;
    } catch (error) {
        console.error("Error verifying Cashfree payment:", error);
        throw error;
    }
};